export const grey800 = '#1B1B17'
export const grey700 = '#3F3F3B'
export const grey600 = '#6F6F6C'
export const grey500 = '#9F9F9D'
export const grey400 = '#CFCFCE'
export const grey300 = '#DBDBDB'
export const grey200 = '#E7E7E6'
export const grey100 = '#F7F7F5'
export const white000 = '#FFFFFE'
export const yellow600 = '#D98F00'
export const yellow400 = '#FFE72D'
export const yellow200 = '#FFED7B'
export const yellow100 = '#FFFAD5'
export const red400 = '#FF7346'
export const red200 = '#FFCBBB'
export const green600 = '#00603A'
export const green400 = '#00B867'
export const green200 = '#80E0BA'
export const green100 = '#D8F7E8'
export const blue600 = '#004C68'
export const blue400 = '#0098CF'
export const blue200 = '#7BD8E6'
export const blue100 = '#D6F6FA'
export const purple200 = '#B398F0'
